import React from 'react';
import { StyledSpinner } from './styled';
export const Spinner = ({ size = 'default', color, colorShade, ...props }) => {
    const isBig = size === 'big';
    return (React.createElement(StyledSpinner, { size: !isBig ? 'large' : undefined, color: color, "$colorShade": colorShade, "$isBig": isBig, ...props }));
};
